enum VariantsType {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    Span = 'span',
    Paragraph = 'p'
}

export default VariantsType;